import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Renew.css";

const PrintLostForm = () => {
  const navigate = useNavigate();
  const [mmyy, setMmyy] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [transaction, setTransaction] = useState(null);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    try {
      const formattedReceipt = `B/${mmyy}/${receiptNo}`;
      const response = await axios.get('https://www.lianfoong.com/api/pawn-transactions/search-by-receipt', {
        params: { receiptNo: formattedReceipt },
      });
      setTransaction(response.data);
      setError("");
    } catch (err) {
      setError("Transaction not found!");
      setTransaction(null);
    }
  };

  const handlePrint = async () => {
    try {
      const formattedReceiptNo = `B/${mmyy}/${receiptNo}`;
      const response = await axios.get('https://www.lianfoong.com/api/print/lost-declaration', {
        params: { receiptNo: formattedReceiptNo },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'lost_declaration.txt');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      navigate('/dashboard');
    } catch (error) {
      console.error('Print failed:', error);
      alert('Print failed. Please try again.');
    }
};

  const formatDateDDMMYYYY = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth()+1).padStart(2, '0')}/${date.getFullYear()}`;
  };

  return (
    <div className="renew-container">
      <h2 className="title">Print Lost Declaration</h2>
      
      {/* Search Form */}
      <div className="form-group">
        <label>Enter Month and Year (MMYY):</label>
        <input 
          value={mmyy} 
          onChange={(e) => setMmyy(e.target.value)} 
          placeholder="MMYY"
        />
      </div>
      <div className="form-group">
        <label>Enter Receipt Number:</label>
        <input 
          value={receiptNo} 
          onChange={(e) => setReceiptNo(e.target.value)} 
          placeholder="Receipt No"
        />
      </div>
      <button className="search-btn" onClick={handleSearch}>Search</button>
      {error && <p className="error-message">{error}</p>}

      {/* Transaction Details & Confirmation */}
      {transaction && (
        <div className="transaction-details">
          <div className="details-grid">
            <p><strong>Items:</strong> {transaction.item}</p>
            <p><strong>Weight:</strong> {transaction.weight}</p>
            <p><strong>Amount:</strong> ${transaction.amount.toFixed(2)}</p>
            <p><strong>Date:</strong> {formatDateDDMMYYYY(transaction.grantDate)}</p>
            <p><strong>Expiry Date:</strong> {formatDateDDMMYYYY(transaction.expiryDate)}</p>
          </div>

          <div className="alert-box">
            <p><strong>Confirm printing of lost declaration form?</strong></p>
            <button onClick={handlePrint}>Yes</button>
            <button onClick={() => setTransaction(null)}>No</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrintLostForm;